
let defaultState = {
    indicative: {},
    projectLead: {},
    app: {}
}



let applicationData = (state = defaultState, action = {}) => {

    switch (action.type) {


        case 'RESET_APPLICATION_DATA':
            return {
                ...defaultState
            }

        case 'UPDATE_APPLICATION_DATA':
            return {...state, app: {...state.app, ...action.data}};

        case 'SET_APPLICATION_PROJECT_LEAD':
            return {...state, projectLead: action.data}

        case 'SET_APPLICATION_INDICATIVE':
            return {...state, indicative: action.data}

        case 'SET_APPLICATION_DATA':
            return {...state, app: action.data || {}}
        
        case 'SET_APPLICATION_BIDS':
            return {...state, bids: action.data}

        default:
            return state
    }
}


export default applicationData;
